<template>
  <div class="print-break-after">
    <!-- Pop-up calendario-->
    <wg-modal :width="'90%'" v-if="showCalendar" @closeModal="showCalendar = !showCalendar">
      <div slot="header" class="wg-row" style="flex-wrap:nowrap;align-items:center;">
        <div class="com-anm22-app-text-xl">{{ $anm22.strLang(lang, 'Calendar', 'Calendario') }}</div>
        <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:center;">
          <img
            class="com-anm22-app-img-fixed-height-s"
            style="cursor:pointer;"
            :src="$anm22.icons.getWorldIcon('arrowLeft')"
            @click="offset--"
          />
          <div class="com-anm22-app-horizontal-space" style="width:10px;"></div>
          <div class="com-anm22-app-text-xl">{{ month | moment('MMMM YYYY') }}</div>
          <div class="com-anm22-app-horizontal-space" style="width:10px;"></div>
          <img
            class="com-anm22-app-img-fixed-height-s"
            style="cursor:pointer;"
            :src="$anm22.icons.getWorldIcon('arrowRight')"
            @click="offset++"
          />
        </div>
      </div>
      <vircos-calendar slot="body" :active="true" :month="month" @setDeliveryDate="setDeliveryDate"></vircos-calendar>
    </wg-modal>
    <!-- DATA ORDINE -->
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div
            class="com-anm22-app-text-m"
          >{{ $anm22.strLang(lang, 'Delivery date', 'Data di consegna') }}</div>
          <div
            class="com-anm22-app-text-m display-flex hidden-input model-row"
            @click="openCalendar"
          >{{ deliveryDate }}</div>
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div
            class="com-anm22-app-text-m"
          >{{ $anm22.strLang(lang, 'Delivery method', 'Metodo di consegna') }}</div>
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select"
            v-model="formData.deliveryType"
          >
            <option v-for="(dm,i) in deliveryTypes" :key="'dm-'+i" :value="dm.id">{{ dm.label }}</option>
          </select>
          <template v-else>
            <input
              v-if="deliveryTypes.find(dm => dm.id === formData.deliveryType)"
              disabled
              class="input-elem com-anm22-app-input-text model-row"
              type="text"
              v-model="deliveryTypes.find(dm => dm.id === formData.deliveryType).label"
            />
          </template>
        </div>
      </div>
    </div>
    <!-- SPEDIZIONE A -->
    <div v-if="formData.deliveryType === 'shipping'" class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Ship to', 'Spedire a') }}</div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <textarea
          class="input-elem com-anm22-app-textarea model-row"
          style="height:100px;width:100%;max-width:unset;"
          v-model.lazy="formData.shippingAddress"
        ></textarea>
      </div>
    </div>
    <!-- TUTA -->
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m" style="display:inline-block;vertical-align:middle">{{ $anm22.strLang(lang, 'Suit', 'Tuta') }}</div>
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select"
            v-model="formData.suitModel"
          >
            <option :value="null">{{ $anm22.strLang(lang, 'Select model', 'Seleziona modello') }}</option>
            <option v-for="(p, i) in suitProducts" :key="'abp-' + i" :value="p.idWarehouseProduct">{{ p.name }}</option>
          </select>
          <template v-else>
            <input
              v-if="suitProducts.find(p => p.idWarehouseProduct === formData.suitModel)"
              disabled
              class="input-elem com-anm22-app-input-text model-row"
              type="text"
              v-model="suitProducts.find(p => p.idWarehouseProduct === formData.suitModel).name"
            />
          </template>
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Price', 'Prezzo') }}</div>
          <input
            class="input-elem com-anm22-app-input-number"
            type="number"
            min="0"
            placeholder="0"
            v-model="formData.price"
          />
        </div>
      </div>
    </div>
    <!-- AIRBAG -->
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m" style="display:inline-block;vertical-align:middle">AirBag</div>
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select"
            v-model="formData.airbag"
          >
            <option :value="null">{{ $anm22.strLang(lang, 'No', 'No') }}</option>
            <option v-for="(p, i) in airbagProducts" :key="'abp-' + i" :value="p.idWarehouseProduct">{{ p.name }}</option>
          </select>
          <template v-else>
            <input
              v-if="airbagProducts.find(p => p.idWarehouseProduct === formData.airbag)"
              disabled
              class="input-elem com-anm22-app-input-text model-row"
              type="text"
              v-model="airbagProducts.find(p => p.idWarehouseProduct === formData.airbag).name"
            />
          </template>
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Price', 'Prezzo') }}</div>
          <input
            class="input-elem com-anm22-app-input-number"
            type="number"
            min="0"
            placeholder="0"
            v-model="formData.airbagPrice"
          />
        </div>
      </div>
    </div>
    <!-- ACCESSORIES -->
    <div 
      v-for="(accessoryItem, aii) in formData.accessories"
      :key="'acc-' + aii"
      class="wg-row input-row"
    >
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m" style="display:inline-block;vertical-align:middle">{{ $anm22.strLang(lang, 'Accessory', 'Accessorio') }}</div>
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select"
            v-model="formData.accessories[aii].product"
          >
            <option :value="null">{{ $anm22.strLang(lang, 'Select product', 'Seleziona prodotto') }}</option>
            <option v-for="(p, i) in accessoryProducts" :key="'acp-' + i" :value="p.idWarehouseProduct">{{ p.name }}</option>
          </select>
          <template v-else>
            <input
              v-if="accessoryProducts.find(p => p.idWarehouseProduct === formData.accessories[aii].product)"
              disabled
              class="input-elem com-anm22-app-input-text model-row"
              type="text"
              v-model="accessoryProducts.find(p => p.idWarehouseProduct === formData.accessories[aii].product).name"
            />
          </template>
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Price', 'Prezzo') }}</div>
          <input
            class="input-elem com-anm22-app-input-number"
            type="number"
            min="0"
            placeholder="0"
            v-model="formData.accessories[aii].price"
          />
          <img :src="$anm22.icons.getWorldIcon('deleteBin')" class="com-anm22-app-img-s" @click="deleteAccessory(aii)" style="cursor:pointer" />
        </div>
      </div>
    </div>
    <!-- ADD ACCESSORY -->
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m" @click="addAccessory()" style="cursor:pointer">{{ $anm22.strLang(lang, '+ Add accessory', '+ Aggiungi accessorio') }}</div>
        </div>
      </div>
    </div>
    <!-- CORRIERE -->
    <div v-if="formData.deliveryType === 'shipping'" class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m" style="display:inline-block;vertical-align:middle">{{ $anm22.strLang(lang, 'Shipping', 'Spedizione') }}</div>
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select"
            v-model="formData.deliveryCarrier"
          >
            <option :value="undefined">{{ $anm22.strLang(lang, 'Select carrier', 'Selezione corriere') }}</option>
            <option v-for="(dm,i) in deliveryCarriers" :key="'dm-'+i" :value="dm.id">{{ dm.label }}</option>
          </select>
          <template v-else>
            <input
              v-if="deliveryCarriers.find(dm => dm.id === formData.deliveryCarrier)"
              disabled
              class="input-elem com-anm22-app-input-text model-row"
              type="text"
              v-model="deliveryCarriers.find(dm => dm.id === formData.deliveryCarrier).label"
            />
          </template>
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Price', 'Prezzo') }}</div>
          <input
            class="input-elem com-anm22-app-input-number"
            type="number"
            min="0"
            placeholder="0"
            v-model="formData.deliveryPrice"
          />
        </div>
      </div>
    </div>
    <!-- PREZZO TOTALE -->
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6"></div>
      <div v-if="mode === 'edit'" class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Total price', 'Prezzo totale') }}</div>
          <input
            class="input-elem com-anm22-app-input-number"
            type="number"
            min="0"
            placeholder="0"
            disabled
            :value="totalPrice"
          />
        </div>
      </div>
    </div>
    <!-- ORDINE CONFERMATO -->
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row" style="height:36px;">
          <div
            class="com-anm22-app-text-m"
          >{{ $anm22.strLang(lang, 'Order confirmed', 'Ordine confermato') }}</div>
          <input
            id="confirmed"
            type="checkbox"
            :value="0"
            style="display:none;"
            v-model="formData.confirmed"
          />
          <label class="label-input-radio" for="confirmed">{{ formData.confirmed ? '✔' : '' }}</label>
        </div>
      </div>
    </div>
    <!-- ONDA VISION ORDER STATUS -->
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row" style="height:36px;">
          <div
            v-if="project.orderNumber && project.orderNumber != 0"
            class="com-anm22-app-text-m"
          >{{ $anm22.strLang(lang, 'Onda Vision TEST order', 'Onda Vision TEST ordine') }} {{ project.orderNumber }}</div>
          <div
            v-else
            class="com-anm22-app-text-m"
          >{{ $anm22.strLang(lang, 'Onda Vision TEST order', 'Ordine Onda Vision TEST') }} 
            <div @click="sendProjectToOnda()" class="vircos-order-send-btn">
              <img :src="$anm22.icons.getWorldIcon('send')" />
              {{ $anm22.strLang(lang, 'Send', 'Invia') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ACCONTO & SALDO -->
    <div v-if="mode === 'edit'" class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6" v-if="!this.project.category || (this.project.category != 2)">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Deposit', 'Acconto') }}</div>
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            placeholder="0"
            v-model="formData.deposit"
          />
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-6" v-if="this.project.category && (this.project.category == 2)">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Quotation', 'Preventivo') }}</div>
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            placeholder="0"
            v-model="formData.quotation"
          />
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row" style="height:36px;">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Balance', 'Saldo') }}</div>
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            placeholder="0"
            v-model="formData.balance"
          />
        </div>
      </div>
    </div>
    <!-- NOTE -->
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Notes', 'Note') }}</div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <textarea
          class="input-elem com-anm22-app-textarea model-row note-row"
          style="height:100px;width:100%;max-width:unset;"
          v-model.lazy="formData.notes"
        ></textarea>
      </div>
    </div>
    <!-- INVIO NOTIFICHE -->
    <div v-if="docs.data.company == 'vrs' || docs.data.company == 'rvt'" class="wg-row input-row no-print">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Thank you email', 'Email di ringraziamento') }}</div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div v-if="notificationSended || formData.notificationThankYou" class="wg-col wg-xs-12 wg-sm-6">
        <div class="vircos-notification-sended">
          <img :src="$anm22.icons.getWorldIcon('check')" />
          {{ $anm22.strLang(lang, 'Sended', 'Inviata') }} {{ $moment.unix(formData.notificationThankYou).format("DD/MM/YYYY HH:mm") }}
        </div>
      </div>
      <div v-else class="wg-col wg-xs-12 wg-sm-6">
        <div @click="sendThankYouNotification()" class="vircos-notification-send-btn">
          <img :src="$anm22.icons.getWorldIcon('send')" />
          {{ $anm22.strLang(lang, 'Send', 'Invia') }}
        </div>
      </div>
    </div>
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Last edit', 'Ultima modifica') }}</div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">{{ lastEditDate + ' ' + lastEditUser }}</div>
      </div>
    </div>
    <div class="vertical-height-div" style="10px;"></div>
    <div v-if="mode === 'edit'" class="wg-row">
      <input type="button" :value="$anm22.strLang(lang, 'Save', 'Salva')" @click="saveForm" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    projectId: [Number, String],
    docs: Object,
    mode: {
      type: String,
      default: "edit"
    }
  },
  data() {
    return {
      formData: {},
      showCalendar: false,
      // Per gestione calendario
      now: this.$moment(),
      offset: 0,
      notificationSended: false,
      products: [],
      productCategories: [],
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user,
      windowWidth: state => state.windowWidth
    }),
    project() {
      return this.$store.getters["projects/get"]([this.projectId]);
    },
    deliveryDate() {
      let string = this.formData.deliveryDate
        ? this.$moment
            .unix(this.formData.deliveryDate)
            .utc()
            .format("DD/MM/YYYY")
        : this.$anm22.strLang(this.lang, "Not set", "Non impostata");
      return string;
    },
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.formData.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.formData.lastUpdate
        ? this.$moment.unix(this.formData.lastUpdate).format("DD/MM/YYYY HH:mm")
        : "";
    },
    month() {
      return this.now.clone().add(this.offset, "months");
    },
    deliveryTypes() {
      return this.$anm22["vircos_getDeliveryTypes"](this);
    },
    deliveryCarriers() {
      return this.$anm22["vircos_getDeliveryCarriers"](this);
    },
    suitProducts() {
      return this.products.filter(p => p.category == 10);
    },
    airbagProducts() {
      return this.products.filter(p => p.category == 9);
    },
    accessoryProducts() {
      return this.products.filter(p => p.category == 8);
    },
    totalPrice() {
      let totalPrice = 0;
      if (this.formData) {
        // Suit price
        if (this.formData.price) {
          totalPrice += parseFloat(this.formData.price);
        }
        // AirBag price
        if (this.formData.airbagPrice) {
          totalPrice += parseFloat(this.formData.airbagPrice);
        }
        // Accessories prices
        if (this.formData.accessories) {
          let i;
          for (i = 0; i < this.formData.accessories.length; i++) {
            if (this.formData.accessories[i].price) {
              totalPrice += parseFloat(this.formData.accessories[i].price);
            }
          }
        }
        // Delivery price
        if (this.formData.deliveryType && this.formData.deliveryType === 'shipping' && this.formData.deliveryPrice) {
          totalPrice += parseFloat(this.formData.deliveryPrice);
        }
      }
      return totalPrice;
    }
  },
  methods: {
    openCalendar() {
      this.showCalendar = true;
    },
    setDeliveryDate(newDate) {
      let ts = this.$moment.utc(newDate).unix();
      this.$set(this.formData, "deliveryDate", ts);
      this.showCalendar = false;
    },
    saveForm() {
      const docs = { ...this.docs };
      docs.delivery = this.formData;
      docs.delivery.lastUser = this.user.idWorldUser;
      docs.delivery.lastUpdate = this.$moment().unix();
      this.$emit("save", docs);
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    sendThankYouNotification() {
      if (this.docs.data.email) {
        this.formData.notificationThankYou = this.$moment().unix();
        this.notificationSended = true;
        this.$http
          .post("vircos/sendThankYouNotification", {
            projectId: this.project.idWorldProject,
            email: this.docs.data.email,
            name: this.docs.data.name,
            surname: this.docs.data.surname
          }, {
            withCredentials: true
          })
          .then(response => {
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        console.log("Notification: Missing customer e-mail");
      }
    },
    loadWarehouseData() {
      this.$http
        .get("products")
        .then((response) => {
          this.products = response.data.products;
          this.productCategories = response.data.categories;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addAccessory() {
      this.formData.accessories = [ ... this.formData.accessories, {
        "product": null,
        "price": null,
      }];
    },
    deleteAccessory(key) {
      this.formData.accessories.splice(key, 1);
    },
    sendProjectToOnda() {
      this.$http
        .post("vircos/onda-send-order?projectId=" + this.project.idWorldProject, null, {
          withCredentials: true
        })
        .then(response => {
          if (response && response.data && response.data.orderNumber) {
            this.project.orderNumber = response.data.orderNumber;
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  created() {
    this.loadWarehouseData();
    this.formData = { ...this.docs.delivery };
    if (this.formData.notes && Array.isArray(this.formData.notes)) {
      if (this.formData.notes.length > 0) {
        this.formData.notes = this.formData.notes[
          this.formData.notes.length - 1
        ].note;
      } else {
        this.formData.notes = "";
      }
    }
    if (!this.formData.suitModel) {
      this.formData.suitModel = null;
    }
    if (!this.formData.airbag) {
      this.formData.airbag = null;
    }
  },
  components: {
    VircosCalendar: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosCalendar.vue")
  }
};
</script>

<style lang="scss" scoped>
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
}
.input-elem {
  width: 200px;
}
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.hidden-input {
  cursor: pointer;
  border-radius: 4px;
  padding: 5px;
  min-height: 36px;
  align-items: center;
  flex-wrap: nowrap;
  &:hover {
    background-color: #eee;
  }
}
.vircos-order-send-btn,
.vircos-notification-send-btn {
  cursor: pointer;
  position: relative;
  padding: 6px 12px 6px 32px;
  background-color: #eee;
  color: #000;
  border-radius: 6px;
  font-size: 14px;
  display: inline-block;

  &:hover {
    background-color: #ddd;
  }

  img {
    position: absolute;
    left: 10px;
    top: 6px;
    width: 16px;
  }
}
.vircos-notification-sended {
  position: relative;
  padding: 6px 12px 6px 22px;
  color: #000;
  border-radius: 6px;
  font-size: 14px;
  display: inline-block;

  img {
    position: absolute;
    left: 0px;
    top: 6px;
    width: 16px;
  }
}
@media print {
  .model-row {
    width: 541px !important;
    max-width: 541px !important;
  }
  .note-row{
    height:541px!important;
  }

  .no-print {
    display: none;
  }
}
</style>
